import React from 'react';
import { stylesTableCell } from '../../styles/Styles';
import { Box } from '@mui/material';

const ListCellHeader = ({icon,text}) => {
    return <Box sx={stylesTableCell.listHeaderCell}>{icon} {text}</Box>
}

export default ListCellHeader;